import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { transaction, transactionFilter } from "../type";

interface TransactionsState {
  transactions?: transaction[];
  totalTransactions?: number;
  totalAmount?: number;
  transactionFilter: transactionFilter;
  invalidateKey: string | Date;
}

const initialState: TransactionsState = {
  transactionFilter: {
    startDate: new Date(),
    endDate: new Date(),
    TrackingNumber: undefined,
    BuyId: undefined,
  },
  invalidateKey: "1",
};

export const transactionsSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    setTransactions: (state, action: PayloadAction<transaction[]>) => {
      state.transactions = action.payload;
    },
    setTotalTransactions: (state, action: PayloadAction<number>) => {
      state.totalTransactions = action.payload;
    },
    setTotalAmount: (state, action: PayloadAction<number>) => {
      state.totalAmount = action.payload;
    },
    setInvalidateKey: (state, action: PayloadAction<string | Date>) => {
      state.invalidateKey = action.payload;
    },
    setTransactionsFilter: (
      state,
      action: PayloadAction<transactionFilter>
    ) => {
      state.transactionFilter = action.payload;
    },
  },
});
export const {
  setInvalidateKey,
  setTransactionsFilter,
  setTransactions,
  setTotalTransactions,
  setTotalAmount,
} = transactionsSlice.actions;
export default transactionsSlice.reducer;
